<modal
  [modalId]="'device-form'"
  [modalSize]="'md'"
  (close)="modalCleanup()">
  <h3 class="d-inline text-capitalize" modal-title>{{deviceId == null ? 'Add Device' : 'Edit Device'}}</h3>
  <div class="modal-inner h-100 pt-3" modal-inner>
    <form class="d-flex flex-column" id="form" [formGroup]="form" autocomplete="off">
      <mat-form-field subscriptSizing="dynamic" class="my-2 custom-form-field">
        <mat-label>Serial Number</mat-label>
        <input required matInput formControlName="serialNumber" [readonly]="deviceId != null" />
        <mat-error>Please enter the device's serial number</mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="my-2 custom-form-field">
        <mat-label>Customer</mat-label>
        <mat-select required formControlName="customerId" ngDefaultControl #customerSelect>
          <mat-option *ngFor="let customer of customers" [value]="customer.id">
            {{ customer.name }}
          </mat-option>
        </mat-select>
        <mat-error>Please select a customer for the device</mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="my-2 custom-form-field">
        <mat-label>Asset Type</mat-label>
        <mat-select formControlName="assetTypeId" ngDefaultControl>
          <mat-option></mat-option>
          <mat-option *ngFor="let assetType of assetTypes" [value]="assetType.id">
            {{ assetType.name }}
          </mat-option>
        </mat-select>
        <button matSuffix mat-icon-button (click)="openAssetTypeExpander(); $event.stopPropagation()" tabindex="-1">
            <i class="fas fa-lg fa-plus"></i>
        </button>
      </mat-form-field>
      <lookup-form [lookupName]="'Asset Type'" [listTitle]="'Asset Types'" [controllerName]="'AssetType'" 
        *ngIf="addingAssetType" (sendCloseEvent)="assetTypeExpanderClosed($event)" (sendDeleteEvent)="assetTypeDeleted()">
      </lookup-form>
      
        <mat-form-field subscriptSizing="dynamic" class="my-2 custom-form-field">
          <mat-label>Asset ID</mat-label>
          <input required matInput formControlName="fleetId" />
          <mat-error>Please enter the device's asset ID</mat-error>
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic" class="my-2 custom-form-field">
            <mat-label>API Key</mat-label>
            <input matInput formControlName="APIKey" />
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic" class="my-2 custom-form-field">
            <mat-label>Asset Group Path</mat-label>
            <input matInput formControlName="assetGroupPath" />
        </mat-form-field>

        <div class="labelled-slider simple-slider">
          <span>Enabled:</span>
          <label class="switch">
            <input type="checkbox" formControlName="enabled">
            <span class="slider round"></span>
          </label>
        </div>

        <div class="labelled-slider simple-slider">
          <span>Recording Map Upload:</span>
          <label class="switch">
            <input type="checkbox" formControlName="enableRecordingMapRequest">
            <span class="slider round"></span>
          </label>
        </div>

        <div class="labelled-slider simple-slider">
          <span>Camera Snapshots Upload:</span>
          <label class="switch">
            <input type="checkbox" formControlName="enableCamerasSnapshotRequest">
            <span class="slider round"></span>
          </label>
        </div>

      <mat-divider class="my-2"></mat-divider>

      <div class="modal-button-row mt-3 px-3 justify-content-between" *ngIf="deviceId != null">
        <button
          mat-flat-button
          color="warn"
          id="delete"
          type="button"
          (click)="deleteDevice()"
          [disabled]="requestInProgress">
          Delete
        </button>
        <button mat-flat-button color="accent" id="edit" (click)="submitForm()" [disabled]="requestInProgress">
          Save Changes
        </button>
      </div>

      <div class="modal-button-row mt-3 px-3 justify-content-end" *ngIf="deviceId == null">
        <button mat-flat-button color="accent" id="add" (click)="submitForm()" [disabled]="requestInProgress">Add Device</button>
      </div>
    </form>
  </div>
</modal>
